import React from 'react';
import { injectIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateUserDetails } from '../../store/user/duck';
import { tracking } from '../../utils/tracking';
import { slidingToggleButtonNoBorder, slidingToggleGroupNoBorder } from '../SlidingToggleButton/noBorderStyles';
//
const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    '@media (max-width: 960px) and (min-width: 600px)': {
      marginBottom: 100
    }
  },
  toggleGroup: {
    position: 'relative',
    backgroundColor: '#f3f5fb',
    borderRadius: '8px !important',
    padding: 6,
    zIndex: 0,
    ...slidingToggleGroupNoBorder
  },
  toggleButton: {
    ...slidingToggleButtonNoBorder,
    borderRadius: '8px !important',
    padding: '0 20px',
    fontWeight: 'normal',
    fontSize: 14,
    height: 36,
    minWidth: 90,
    color: '#616161',
    textTransform: 'none',
    zIndex: 2,
    backgroundColor: 'transparent',
    transition: 'color 0.25s ease !important',
    WebkitTapHighlightColor: 'transparent',
    '&:hover': {
      backgroundColor: 'rgba(57, 102, 248, 0.04)',
      border: 'none !important',
      borderColor: 'transparent !important',
      boxShadow: 'none'
    }
  },
  selected: {
    color: '#ffffff !important',
    backgroundColor: 'transparent !important',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  slidingIndicator: {
    position: 'absolute',
    top: 6,
    bottom: 6,
    left: 6,
    width: 'calc(50% - 6px)',
    backgroundColor: '#3966f8',
    borderRadius: 8,
    boxShadow: '0 4px 10px rgba(57, 102, 248, 0.2)',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    zIndex: 1
  }
}));

const VersionToggleButton = ({ intl, version, setVersion }) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const [localVersion, setLocalVersion] = React.useState(version);

  React.useEffect(() => {
    setLocalVersion(version);
  }, [version]);

  const handleChange = (event, newVersion) => {
    if (newVersion !== null && newVersion !== localVersion) {
      tracking(`UI Version Change`, { 'current-version': version, 'next-version': newVersion });
      setLocalVersion(newVersion);
      setTimeout(() => {
        setVersion(newVersion);
        sessionStorage.setItem('version', newVersion);
        dispatch(updateUserDetails({ version: newVersion }));
      }, 350);
    }
  };

  const getIndex = val => (val === 'lite' ? 1 : 0);

  return (
    <div className={classes.root}>
      <ToggleButtonGroup
        value={localVersion}
        exclusive
        onChange={handleChange}
        aria-label="version toggle"
        classes={{ root: classes.toggleGroup }}
      >
        <div
          className={classes.slidingIndicator}
          style={{
            transform: `translateX(${getIndex(localVersion) * 100}%)`
          }}
        />
        <ToggleButton value="pro" classes={{ root: classes.toggleButton, selected: classes.selected }}>
          {intl.formatMessage({ id: 'pro-version' })}
        </ToggleButton>
        <ToggleButton value="lite" classes={{ root: classes.toggleButton, selected: classes.selected }}>
          {intl.formatMessage({ id: 'lite-version' })}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default injectIntl(VersionToggleButton);
